import { Origin, Category } from "../todo-list.types.js";
const getCategoryTitles = (labels) => ({
  [Category.APPOINTMENT_HANDLING]: labels == null ? void 0 : labels.category.appointmentRescheduling,
  [Category.OPEN_HKP]: labels == null ? void 0 : labels.category.openHKP,
  [Category.FOLLOWUP_APPOINTMENT]: labels == null ? void 0 : labels.category.followupAppointment,
  [Category.COST_PLAN]: labels == null ? void 0 : labels.category.costPlan
});
const getOriginTitles = (labels) => ({
  [Origin.AUTO_ONLINE_CANCELLATION]: labels == null ? void 0 : labels.origin.autoOnlineCancellation,
  [Origin.AUTO_ACCEPTED_HKP_NO_FOLLOWUP]: labels == null ? void 0 : labels.origin.autoAcceptedHkpNoFollowup,
  [Origin.AUTO_HKP_FOLLOWUP]: labels == null ? void 0 : labels.origin.autoHkpFollowup,
  [Origin.MANUAL]: labels == null ? void 0 : labels.origin.manual
});
const updateTodo = (todo, updatedValues) => ({
  ...todo,
  status: updatedValues.status,
  ignoreComment: updatedValues.ignoreComment
});
const mapTodo = (sseEvent) => ({
  ...sseEvent,
  referenceId: sseEvent.resourceId.referenceId,
  origin: sseEvent.taskOrigin
});
const ORIGINS_WHITELIST = [
  Origin.AUTO_ACCEPTED_HKP_NO_FOLLOWUP,
  Origin.AUTO_HKP_FOLLOWUP,
  Origin.AUTO_ONLINE_CANCELLATION
];
const filterTodos = (todo) => ORIGINS_WHITELIST.includes(todo.origin) && !!todo.patient;
export {
  filterTodos,
  getCategoryTitles,
  getOriginTitles,
  mapTodo,
  updateTodo
};
